/* Publish by EComposer at 2026-10-29 21:10:46*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-8ga5sil6ssb"]=  window.__ectimmers["ecom-8ga5sil6ssb"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-8ga5sil6ssb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ga5sil6ssb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s7x40luct6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s7x40luct6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m8faiw2po5s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m8faiw2po5s', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-jy1ib3kf3s"]=  window.__ectimmers["ecom-jy1ib3kf3s"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-jy1ib3kf3s"]["bv42tg9mm"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-jy1ib3kf3s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jy1ib3kf3s', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oqr9aspaxxg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oqr9aspaxxg', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sxuzygug1u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sxuzygug1u', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-anknh3agr57').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-anknh3agr57', settings: {"link":"lightbox","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}